export const IconWithTextData_01 = [
    {
        img: "/assets/img/webp/litho-react-landing-page-icon-01.webp",
        title: "Power elite author",
    },
    {
        img: "/assets/img/webp/litho-react-landing-page-icon-02.webp",
        title: "Build on latest react hooks",
    },
    {
        img: "/assets/img/webp/litho-react-landing-page-icon-03.webp",
        title: "Framer motion for animation",
    },
    {
        img: "/assets/img/webp/litho-react-landing-page-icon-04.webp",
        title: "Tailwind css framwork",
    }
]

export const LandingData = [
    {

        category: ["CORPORATE"],
        frontimg: "/assets/img/webp/litho-demo-startup.webp",
        title: "Startup",
        subtitle: "Business, Finance, Agency",
        link: "/home-startup"
    },
    {
        category: ["SPECIALIZED"],
        frontimg: "/assets/img/webp/litho-demo-yoga-meditation.webp",
        title: "Yoga Meditation",
        subtitle: "Spiritual, Fitness, Classes",
        link: "/home-yoga-meditation"
    },
    {
        category: ["SPECIALIZED"],
        frontimg: "/assets/img/webp/litho-demo-restaurant.webp",
        title: "Restaurant",
        subtitle: "Food, Dining, Cafe",
        link: "/home-restaurant"
    },
    {
        category: ["CORPORATE"],
        frontimg: "/assets/img/webp/litho-demo-marketing-agency.webp",
        title: "Marketing Agency",
        subtitle: "Sales, Consulting, Advertising",
        link: "/home-marketing-agency"
    },
    {
        category: ["SPECIALIZED"],
        frontimg: "/assets/img/webp/litho-demo-architecture.webp",
        title: "Architecture",
        subtitle: "Planning, Interior, Landscaping",
        link: "/home-architecture"
    },
    {
        category: ["PORTFOLIO"],
        frontimg: "/assets/img/webp/litho-demo-design-agency.webp",
        title: "Design Agency",
        subtitle: "Graphics, Branding, Development",
        link: "/home-design-agency"
    },
    {
        category: ["SPECIALIZED"],
        frontimg: "/assets/img/webp/litho-demo-gym-fitness.webp",
        title: "Gym Fitness",
        subtitle: "Sports, Crossfit, Diet",
        link: "/home-gym-fitness"
    },
    {
        category: ["SPECIALIZED"],
        frontimg: "/assets/img/webp/litho-demo-travel-agency.webp",
        title: "Travel Agency",
        subtitle: "Hotels, Vacation, Tours",
        link: "/home-travel-agency"
    },
    {
        category: ["CORPORATE"],
        frontimg: "/assets/img/webp/litho-demo-creative-business.webp",
        title: "Business",
        subtitle: "Corporate, Account, Consulting",
        link: "/home-business"
    },
    {
        category: ["PORTFOLIO"],
        frontimg: "/assets/img/webp/litho-demo-personal-portfolio.webp",
        title: "Personal Portfolio",
        subtitle: "Resume, Photography, Freelancer",
        link: "/home-personal-portfolio"
    },
    {
        category: ["PORTFOLIO"],
        frontimg: "/assets/img/webp/litho-demo-branding-agency.webp",
        title: "Branding Agency",
        subtitle: "Services, Advertising, SEO",
        link: "/home-branding-agency"
    },
    {
        category: ["SPECIALIZED"],
        frontimg: "/assets/img/webp/litho-demo-interior-design.webp",
        title: "Interior Design",
        subtitle: "Decor, Furniture, Architecture",
        link: "/home-interior-design"
    },
    {
        category: ["PORTFOLIO"],
        frontimg: "/assets/img/webp/litho-demo-creative-agency.webp",
        title: "Creative Agency",
        subtitle: "Designs, Web, Graphics",
        link: "/home-creative-agency"
    },
    {
        category: ["CORPORATE"],
        frontimg: "/assets/img/webp/litho-demo-seo-agency.webp",
        title: "SEO Agency",
        subtitle: "Advertising, Marketing, SEO Services",
        link: "/home-seo-agency"
    },
    {
        category: ["CORPORATE"],
        frontimg: "/assets/img/webp/litho-demo-corporate.webp",
        title: "Corporate",
        subtitle: "Accounting, Company, Business",
        link: "/home-corporate"
    },
    {
        category: ["BLOG"],
        frontimg: "/assets/img/webp/litho-demo-magazine.webp",
        title: "Magazine",
        subtitle: "Newspaper, Videos, Blogs",
        link: "/home-magazine"
    },
    {
        category: ["CORPORATE"],
        frontimg: "/assets/img/webp/litho-demo-digital-agency.webp",
        title: "Digital Agency",
        subtitle: "SEO, Marketing, Web",
        link: "/home-digital-agency"
    },
    {
        category: ["SPECIALIZED"],
        frontimg: "/assets/img/webp/litho-demo-home-cafe.webp",
        title: "Cafe",
        subtitle: "Coffee, Bar, Takeaway",
        link: "/home-cafe"
    },
    {
        category: ["PORTFOLIO"],
        frontimg: "/assets/img/webp/litho-demo-web-agency.webp",
        title: "Web Agency",
        subtitle: "Digital, Web, Development",
        link: "/home-web-agency"
    },
    {
        category: ["CORPORATE"],
        frontimg: "/assets/img/webp/litho-demo-coming-soon.webp",
        title: "Coming Soon",
        subtitle: "Launching, Event, Announcement",
        link: "/page/coming-soon"
    },
    {
        category: [""],
        frontimg: "/assets/img/webp/litho-demo-application.webp",
        title: "Application",
        subtitle: "Mobile, Android, iPhone",
        link: "/home-application"
    },
    {
        category: [""],
        frontimg: "/assets/img/webp/litho-demo-maintenance.webp",
        title: "Maintenance",
        subtitle: "Under Construction, Maintenance",
        link: "/page/maintenance"
    },
    {
        category: ["CORPORATE"],
        frontimg: "/assets/img/webp/litho-demo-finance.webp",
        title: "Finance",
        subtitle: "Auditing, Planning, Investment",
        link: "/home-finance"
    },
    {
        category: ["PORTFOLIO"],
        frontimg: "/assets/img/webp/litho-demo-vertical-portfolio.webp",
        title: "Vertical Portfolio",
        subtitle: "Design, Photography, Freelancer",
        link: "/home-vertical-portfolio"
    },
    {
        category: ["BLOG"],
        frontimg: "/assets/img/webp/litho-demo-lifestyle-blog.webp",
        title: "Lifestyle Blog",
        subtitle: "Fashion, Culture, Personal",
        link: "/home-lifestyle-blog"
    },
    {
        category: ["PORTFOLIO"],
        frontimg: "/assets/img/webp/litho-demo-split-portfolio.webp",
        title: "Split Portfolio",
        subtitle: "CV, Design, Photography",
        link: "/home-split-portfolio"
    },
    {
        category: ["BLOG"],
        frontimg: "/assets/img/webp/litho-demo-classic-blog.webp",
        title: "Classic Blog",
        subtitle: "Author, Blogging, Writer",
        link: "/home-classic-blog"
    },
    {
        category: ["PORTFOLIO"],
        frontimg: "/assets/img/webp/litho-demo-photography.webp",
        title: "Photography",
        subtitle: "Studio, Designs, Products",
        link: "/home-photography"
    },
    {
        category: ["SPECIALIZED"],
        frontimg: "/assets/img/webp/litho-demo-dentist.webp",
        title: "Dentist",
        subtitle: "Medical, Doctor, Hospital",
        link: "/home-dentist"
    },
    {
        category: ["E-COMMERCE"],
        frontimg: "/assets/img/webp/litho-demo-furniture-shop.webp",
        title: "Furniture Shop",
        subtitle: "Handmade, Lighting, Wooden",
        link: "/home-furniture-shop"
    },
    {
        category: ["CORPORATE"],
        frontimg: "/assets/img/webp/litho-demo-events-conference.webp",
        title: "Events Conference",
        subtitle: "Marketer, Meetup, Seminars",
        link: "/home-events-conference"
    },
    {
        category: ["E-COMMERCE"],
        frontimg: "/assets/img/webp/litho-demo-fashion-shop.webp",
        title: "Fashion Shop",
        subtitle: "Clothes, Shopping, e-Commerce",
        link: "/home-fashion-shop"
    },
    {
        category: ["PORTFOLIO"],
        frontimg: "/assets/img/webp/litho-demo-creative-portfolio.webp",
        title: "Creative Portfolio",
        subtitle: "Design, Photography, Resume",
        link: "/home-creative-portfolio"
    },
    {
        category: ["SPECIALIZED"],
        frontimg: "/assets/img/webp/litho-demo-spa-salon.webp",
        title: "Spa Salon",
        subtitle: "Barbour, Therapist, Wellness",
        link: "/home-spa-salon"
    },
    {
        category: ["SPECIALIZED"],
        frontimg: "/assets/img/webp/litho-demo-home-decor.webp",
        title: "Home Decor",
        subtitle: "Accessories,  Planter, Bedding",
        link: "/home-decor"
    },
    {
        category: ["SPECIALIZED"],
        frontimg: "/assets/img/webp/litho-demo-hotel-resort.webp",
        title: "Hotel Resort",
        subtitle: "Banquets, Party, Events",
        link: "/home-hotel-resort"
    },
    {
        category: ["CORPORATE"],
        frontimg: "/assets/img/webp/litho-demo-consulting.webp",
        title: "Consulting",
        subtitle: "Legal, Advisor, Consultants",
        link: "/home-consulting"
    },
    {
        category: ["PORTFOLIO"],
        frontimg: "/assets/img/webp/litho-demo-interactive-portfolio.webp",
        title: "Interactive Portfolio",
        subtitle: "Design, Photography, Resume",
        link: "/home-interactive-portfolio"
    },
    {
        category: ["PORTFOLIO"],
        frontimg: "/assets/img/webp/litho-demo-freelancer.webp",
        title: "Freelancer",
        subtitle: "Portfolio, Agency, Services",
        link: "/home-freelancer"
    },
]

export const SwiperImgData = [
    {
        img: "/assets/img/webp/litho-inner-page-slider-01.webp",
    },
    {
        img: "/assets/img/webp/litho-inner-page-slider-02.webp"
    },
    {
        img: "/assets/img/webp/litho-inner-page-slider-04.webp"
    },
    {
        img: "/assets/img/webp/litho-inner-page-slider-03.webp"
    },
    {
        img: "/assets/img/webp/litho-inner-page-slider-05.webp"
    },
    {
        title: "single-project-page-01",
        img: "/assets/img/webp/litho-demo-single-project-page-01.webp",
        link: "/portfolio/single-project-page-01"
    },
    {
        title: "single-project-page-02",
        img: "/assets/img/webp/litho-demo-single-project-page-02.webp",
        link: "/portfolio/single-project-page-02"
    },
    {
        title: "single-project-page-03",
        img: "/assets/img/webp/litho-demo-single-project-page-03.webp",
        link: "/portfolio/single-project-page-03"
    },
    {
        title: "single-project-page-04",
        img: "/assets/img/webp/litho-demo-single-project-page-04.webp",
        link: "/portfolio/single-project-page-04"
    },
    {
        title: "single-project-page-05",
        img: "/assets/img/webp/litho-demo-single-project-page-05.webp",
        link: "/portfolio/single-project-page-05"
    },
    {
        title: "blog-post-layout-01",
        img: "/assets/img/webp/litho-demo-blog-post-layout-01.webp",
        href: "/blogs/blog-post-layout-01"
    },
    {
        title: "blog-post-layout-02",
        img: "/assets/img/webp/litho-demo-blog-post-layout-02.webp",
        href: "/blogs/blog-post-layout-02"
    },
    {
        title: "blog-post-layout-03",
        img: "/assets/img/webp/litho-demo-blog-post-layout-03.webp",
        href: "/blogs/blog-post-layout-03"
    },
    {
        title: "blog-post-layout-04",
        img: "/assets/img/webp/litho-demo-blog-post-layout-04.webp",
        href: "/blogs/blog-post-layout-04"
    },
    {
        title: "blog-post-layout-05",
        img: "/assets/img/webp/litho-demo-blog-post-layout-05.webp",
        href: "/blogs/blog-post-layout-05"
    },
    {
        img: "/assets/img/webp/litho-templates-library-01.webp"
    },
    {
        img: "/assets/img/webp/litho-templates-library-02.webp"
    },
    {
        img: "/assets/img/webp/litho-templates-library-03.webp"
    },
    {
        img: "/assets/img/webp/litho-templates-library-04.webp"
    },
    {
        img: "/assets/img/webp/litho-templates-library-05.webp"
    },
    {
        img: "/assets/img/webp/litho-templates-library-06.webp"
    },
    {
        img: "/assets/img/webp/litho-templates-library-07.webp"
    },
]

export const FeaturesData = [
    {
        img: "/assets/img/webp/litho-react-landing-page-icon-05.webp",
        title: "Bootstrap 5 Framework"
    },
    {
        img: "/assets/img/webp/litho-react-landing-page-icon-06.webp",
        title: "Atropos JavaScript"
    },
    {
        img: "/assets/img/webp/litho-landing-page-icon-03.webp",
        title: "Google Web Fonts"
    },
    {
        img: "/assets/img/webp/litho-landing-page-icon-04.webp",
        title: "Instagram Feed"
    },
    {
        img: "/assets/img/webp/litho-react-landing-page-icon-07.webp",
        title: "Formik Form Validation"
    },
    {
        img: "/assets/img/webp/litho-react-landing-page-icon-08.webp",
        title: "Parallax Effect"
    },
    {
        img: "/assets/img/webp/litho-landing-page-icon-07.webp",
        title: "Isotope Filtering"
    },
    {
        img: "/assets/img/webp/litho-landing-page-icon-08.webp",
        title: "Swiper Touch Slider"
    },
    {
        img: "/assets/img/webp/litho-react-landing-page-icon-10.webp",
        title: "Framer Motion"
    },
    {
        img: "/assets/img/webp/litho-landing-page-icon-10.webp",
        title: "Magnific Popup"
    }
]

export const ElementsData = [
    {
        icon: "feather-target",
        title: "Animations",
    },
    {
        icon: "feather-bell",
        title: "Alert Boxes",
    },
    {
        icon: "feather-navigation",
        title: "Buttons",
    },
    {
        icon: "feather-message-square",
        title: "Blockquotes",
    },
    {
        icon: "feather-arrow-right-circle",
        title: "Call To Action",
    },
    {
        icon: "feather-layers",
        title: "Carousel",
    },
    {
        icon: "feather-pie-chart",
        title: "Pie Charts",
    },
    {
        icon: "feather-user",
        title: "Clients",
    },
    {
        icon: "feather-sidebar",
        title: "Column Grids",
    },
    {
        icon: "feather-mail",
        title: "Newsletter",
    },
    {
        icon: "feather-calendar",
        title: "Event Tab",
    },
    {
        icon: "feather-help-circle",
        title: "FAQs",
    },
    {
        icon: "feather-box",
        title: "Flip Box",
    },
    {
        icon: "feather-server",
        title: "Forms",
    },
    {
        icon: "feather-image",
        title: "Galleries",
    },
    {
        icon: "feather-book-open",
        title: "Info Boxes",
    },
    {
        icon: "feather-maximize",
        title: "Lightbox",
    },
    {
        icon: "feather-map-pin",
        title: "Maps",
    },
    {
        icon: "feather-video",
        title: "Media Embeds",
    },
    {
        icon: "feather-external-link",
        title: "Modals",
    },
    {
        icon: "feather-menu",
        title: "Accordion",
    },
    {
        icon: "feather-maximize-2",
        title: "Parallax",
    },
    {
        icon: "feather-folder",
        title: "Mega Menu",
    },
    {
        icon: "feather-align-left",
        title: "Progress Bars",
    },
    {
        icon: "feather-percent",
        title: "Promo Boxes",
    },
    {
        icon: "feather-dollar-sign",
        title: "Pricing Tables",
    },
    {
        icon: "feather-repeat",
        title: "Process Steps",
    },
    {
        icon: "feather-grid",
        title: "Portfolio",
    },
    {
        icon: "feather-star",
        title: "Ratings",
    },
    {
        icon: "feather-tablet",
        title: "Responsive",
    },
    {
        icon: "feather-sidebar",
        title: "Sidebar",
    },
    {
        icon: "feather-shopping-cart",
        title: "e-Commerce",
    },
    {
        icon: "feather-globe",
        title: "Social Icons",
    },
    {
        icon: "feather-sidebar",
        title: "Tables",
    },
    {
        icon: "feather-type",
        title: "Text Rotator",
    },
    {
        icon: "feather-credit-card",
        title: "Tabs",
    },
    {
        icon: "feather-message-circle",
        title: "Testimonials",
    },
    {
        icon: "feather-eye",
        title: "Retina Ready",
    },
    {
        icon: "feather-search",
        title: "SEO Optimized",
    },
    {
        icon: "feather-filter",
        title: "Unlimited Colors",
    },
    {
        icon: "feather-edit",
        title: "Documentation",
    },
    {
        icon: "feather-rotate-cw",
        title: "Free Updates",
    }
]

export const TestimonialsData = [
    {
        name: 'Adorn Themes',
        content: 'Every element is designed beautifully and pixel perfect, so it is really a modern theme. Support team is very kind.',
        img: '/assets/img/webp/litho-landing-page-img-12.webp',
        rating: 5
    },
    {
        name: 'Ben AVW',
        content: "You don't need a web developer to use this theme. Simple and easy to integrate and build the whole website.",
        img: '/assets/img/webp/litho-landing-page-img-12.webp',
        rating: 5
    },
    {
        name: 'Chantal Winston',
        content: "Out of all the themes that I have purchased and customized, this is the 1st one that didn't require any support.",
        img: '/assets/img/webp/litho-landing-page-img-12.webp',
        rating: 5
    },
    {
        name: 'Studio JAS',
        content: "While everything is great about this quality to flexibility. I'm using this theme for 5 websites.",
        img: '/assets/img/webp/litho-landing-page-img-12.webp',
        rating: 5
    },
    {
        name: 'Brent Nolan',
        content: 'Support for this product has always been above and beyond, their technical team has been very reliable.',
        img: '/assets/img/webp/litho-landing-page-img-12.webp',
        rating: 5
    },
    {
        name: 'Forextv',
        content: 'I have limited coding skills and these guys make it simple. Recommend this theme and support team.',
        img: '/assets/img/webp/litho-landing-page-img-12.webp',
        rating: 5
    },
    {
        name: 'Super Mario',
        content: 'A professional template with a great code quality and a very detailed and understandable documentation.',
        img: '/assets/img/webp/litho-landing-page-img-12.webp',
        rating: 5
    }
]

export const CounterData = [
    {
        number: {
            text: "200"
        },
        title: "Ready elements",
    },
    {
        number: {
            text: "230"
        },
        title: "Pre-made templates",
    }
]



export const LandingDemoData = [
    {

        category: [""],
        frontimg: "/assets/img/webp/litho-demo-startup.webp",
        title: "Startup",
        link: "/home-startup"
    },
    {
        category: [""],
        frontimg: "/assets/img/webp/litho-demo-yoga-meditation.webp",
        title: "Yoga Meditation",
        link: "/home-yoga-meditation"
    },
    {
        category: [""],
        frontimg: "/assets/img/webp/litho-demo-restaurant.webp",
        title: "Restaurant",
        link: "/home-restaurant"
    },
    {
        category: [""],
        frontimg: "/assets/img/webp/litho-demo-corporate.webp",
        title: "Corporate",
        link: "/home-corporate"
    },
    {
        category: [""],
        frontimg: "/assets/img/webp/litho-demo-architecture.webp",
        title: "Architecture",
        link: "/home-architecture"
    },
    {
        category: [""],
        frontimg: "/assets/img/webp/litho-demo-design-agency.webp",
        title: "Design Agency",
        link: "/home-design-agency"
    },
    {
        category: [""],
        frontimg: "/assets/img/webp/litho-demo-marketing-agency.webp",
        title: "Marketing Agency",
        link: "/home-marketing-agency"
    },
    {
        category: [""],
        frontimg: "/assets/img/webp/litho-demo-freelancer.webp",
        title: "Freelancer",
        link: "/home-freelancer"
    },
    {
        category: [""],
        frontimg: "/assets/img/webp/litho-demo-travel-agency.webp",
        title: "Travel Agency",
        link: "/home-travel-agency"
    },
]